import { Injectable } from '@angular/core';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { Global } from 'src/app/core/resources/global';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Anomaly, AnomalyType } from 'src/app/core/interfaces/anomaly';

@Injectable({
  providedIn: 'root'
})
export class CargoTripAnomalyService {

  constructor(
    private _http: HttpClient,
    private _endpointResources: Endpoints,
    private _globalResources: Global,
  ) { }

  getTripAnomaly(): Observable<Anomaly[]> {
    return this._http.get<Anomaly[]>(
      `${environment.urlServerTeclogi}${this._endpointResources.getTripAnomaly}`,
    ).pipe(
      map((anomalies: Anomaly[]) => anomalies.slice().sort((a: Anomaly, b: Anomaly) =>
        (a.name || '').localeCompare(b.name || '')
      ))
    );
  }

  getTripAnomalyByType(type: AnomalyType): Observable<Anomaly[]> {
    return this._http.get<Anomaly[]>(
      `${environment.urlServerTeclogi}${this._endpointResources.getTripAnomalyByType}?serviceType=${type}`,
    ).pipe(
      map((anomalies: Anomaly[]) => anomalies.slice().sort((a: Anomaly, b: Anomaly) =>
        (a.name || '').localeCompare(b.name || '')
      ))
    );
  }

  createTripAnomaly(data, idCargo: string) {
    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.createTripAnomaly + idCargo,
      data
    );
  }

  updateTripAnomaly(data, idCargo: string, idAnomaly: number) {
    return this._http.put(
      `${environment.urlServerTeclogi}${this._endpointResources.updateTripAnomaly}${idCargo}?id=${idAnomaly}`,
      data
    )
  }
}


